import { GET_BGM_COMPANIES_REQUEST } from 'redux/actions';
import { takeLatest, all } from 'redux-saga/effects';
import { getBgmCompaniesSaga } from './getBgmCompaniesSaga';

export function* dakBgmUserWatcher() {
  yield all([yield takeLatest(GET_BGM_COMPANIES_REQUEST, getBgmCompaniesSaga)]);
}
